import * as c from '../constants/StudentsExamSchedulesConstants'
import { DEFAULT_REQUEST_ERROR } from '../constants/MessageConstants'
import axios, { getServerErrorMessage } from '../utils/axios'

export const fetchExamsSchedule = studentId => (dispatch, getState) => {
  const educationPeriodCd = getState().settingsEducationPeriod.current

  dispatch({ type: c.FETCH_STUDENT_EXAMS_SCHEDULE_PENDING })
  return axios.get(`${Config.API_URL}/enrollments/education-periods/${educationPeriodCd}/students/${studentId}/student-exams`)
    .then(res => dispatch({ type: c.FETCH_STUDENT_EXAMS_SCHEDULE_FULFILLED, payload: { studentId, data: res.data }}))
    .catch(err => dispatch({ type: c.FETCH_STUDENT_EXAMS_SCHEDULE_REJECTED, payload: getServerErrorMessage(err || DEFAULT_REQUEST_ERROR) }))
}